import React, { useState } from 'react';
import { Button, Box, TextField, Snackbar, Alert } from '@mui/material';
import styles from './SignIn.module.scss';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { sigInCallback } from '../../../api/auth';
import { useNavigate } from 'react-router-dom';
import localStorageService from '../../../services/localStorageService';
import { auth } from '../../../firebase';

export const SignIn = () => {
  const navigate = useNavigate();
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [authError, setAuthError] = useState('');
  
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email');
    const password = data.get('password');
    
    try {
      if (email && password) {
        const user: any = await signInWithEmailAndPassword(auth(), email.toString(), password.toString())
          .then((userCredential) => {
            return userCredential.user;
          })
          .catch((error) => {
            const errorMessage = error.message;
            console.log(errorMessage);
            
            if (errorMessage === 'Firebase: Error (auth/user-not-found).') {
              setAuthError('This user does not exist, try using another email to sign in');
            }
            if (errorMessage === 'Firebase: Error (auth/wrong-password).') {
              setAuthError('You entered the wrong password, please try another password for this user');
            }
            
            setIsOpenSnackbar(true);
            return null;
          });
  
        localStorageService.setAccessToken(user?.accessToken);
        await sigInCallback({email: email.toString(), firebaseId: user?.uid || ''});
        navigate('/leagues');
      }
    } catch (e) {
      console.log(e);
    }
  };
  
  const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") return;
    setIsOpenSnackbar(false);
  };
  
  return (
    <div className="">
      <div className={styles.background} />
      <Box component="form" onSubmit={handleSubmit} noValidate className={styles.loginFormContainer}>
        <span className="block text-3xl font-bold text-gray">Sign in to Hajem admin</span>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Sign In
        </Button>
        {/*<Link href="/sign-up" variant="body2">Don't have an account? Sign Up</Link>*/}
      </Box>
      <Snackbar
        sx={{ height: "5%" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={isOpenSnackbar}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: "100%" }}>
          {authError}
        </Alert>
      </Snackbar>
    </div>
  )
}